"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var styles = (0, _makeStyles.default)(function (theme) {
  return {
    swiper: {
      position: "relative"
    },
    swiperNav: {
      alignItems: "center",
      background: "rgba(0, 0, 0, 0.2)",
      cursor: "pointer",
      color: "#FFFFFF",
      display: "flex",
      height: 60,
      justifyContent: "center",
      position: "absolute",
      top: "50%",
      transform: "translate(0, -50%)",
      userSelect: "none",
      width: 30,
      zIndex: 1,
      "&.swiper-button-disabled": {
        opacity: 0.5,
        pointerEvents: "none"
      }
    },
    swiperNavPrev: {
      borderRadius: "0px 60px 60px 0px",
      left: 0
    },
    swiperNavNext: {
      borderRadius: "60px 0px 0px 60px",
      right: 0
    },
    item: {
      cursor: "pointer"
    }
  };
});
var _default = styles;
exports.default = _default;